// Show extra fields
// eslint-disable-next-line max-len
// const eventRadioButtons = document.querySelectorAll('.event-form__part-of-event .visiting-group, .event-form__part-of-event .tour-group');
// eventRadioButtons.forEach((input) => {
//   const parentElem = input.closest('.event-form');

//   input.addEventListener('change', (el) => {
//     parentElem.classList.add('is-open-content');
//     const parentRadio = el.target.closest('.radio-button');
//     const hiddenContent = parentElem.querySelector('.event-form__hidden-content');
//     const hiddenContentRadioBtn = hiddenContent.querySelectorAll('input[type="radio"]');

//     const visitingRadioGroup = hiddenContent.querySelector('.visiting-time-group');
//     const tourRadioGroup = hiddenContent.querySelector('.tour-time-group');

//     // Hide/Show radio group
//     if (parentRadio.classList.contains('visiting-group')) {
//       visitingRadioGroup.classList.add('is-active');
//       tourRadioGroup.classList.remove('is-active');
//     }

//     // Hide/Show radio group
//     if (parentRadio.classList.contains('tour-group')) {
//       tourRadioGroup.classList.add('is-active');
//       visitingRadioGroup.classList.remove('is-active');
//     }

//     // Remove all required
//     hiddenContentRadioBtn.forEach((radio) => {
//       radio.removeAttribute('required');
//     });

//     // Add required on visiting-group
//     if (el.target.closest('.visiting-group')) {
//       const hiddenVisitingRadioBtn = visitingRadioGroup.querySelectorAll('input[type="radio"]');
//       hiddenVisitingRadioBtn.forEach((radio) => {
//         radio.setAttribute('required', '');
//       });
//     }

//     // Add required on tour-group
//     if (el.target.closest('.tour-group')) {
//       const hiddenTourRadioBtn = tourRadioGroup.querySelectorAll('input[type="radio"]');
//       hiddenTourRadioBtn.forEach((radio) => {
//         radio.setAttribute('required', '');
//       });
//     }
//   });
// });

// *******************************************************************************
// Event form validation
// *******************************************************************************

const eventHandleForm = async (form) => {
  const formAction = form.querySelector('[data-form-action]').value;
  const nonce = await getNonceForAction(formAction);

  const axiosAction = (requiredFormData, otherFormData) => {
    grecaptcha.ready(() => {
      grecaptcha.execute(localData.captchaSiteKey, { action: formAction }).then((token) => {
        const formErrorMessage = form.querySelector('.form-error-message');
        const formDataInput = new FormData();
        formDataInput.append('action', formAction);
        formDataInput.append('nonce', nonce);
        formDataInput.append('requiredInputs', JSON.stringify(requiredFormData));
        formDataInput.append('otherInputs', JSON.stringify(otherFormData));
        formDataInput.append('lang', localData.lang);
        formDataInput.append('id', localData.id);
        formDataInput.append('token', token);
        axios
          .post(localData.apiURL, formDataInput, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((response) => {
            if (response.status === 200 && response.data.data.thankYou === true) {
              form.closest('.event-form').classList.add('show-thankyou');
            }
            if (response.status !== 200) {
              if (response.response.data.data.msg) {
                formErrorMessage.innerHTML = response.response.data.data.msg;
              }
              formErrorMessage.classList.add('is-validation-failed');
            }
          })
          .catch((err) => {
            if (err.response.data.data.msg) {
              formErrorMessage.innerHTML = err.response.data.data.msg;
            }
            formErrorMessage.classList.add('is-validation-failed');
          });
      });
    });
  };

  const fv = FormValidation.formValidation(form, {
    locale: 'sl_SI',
    localization: FormValidation.locales.sl_SI,
    fields: {},
    plugins: {
      message: new FormValidation.plugins.Message({
        container: (field, element) => element.closest('.mod-input,.checkbox,.radio-button'),
      }),
      declarative: new FormValidation.plugins.Declarative({
        html5Input: true,
      }),
      trigger: new FormValidation.plugins.Trigger(),
      excluded: new FormValidation.plugins.Excluded(),
      submitButton: new FormValidation.plugins.SubmitButton(),
    },
  })
    .on('core.element.validated', (e) => {
      // e.element presents the field element
      // e.valid indicates the field is valid or not

      if (e.element.hasAttribute('required')) {
        // Get the field value
        const value = fv.getElementValue(e.field, e.element);
        const container = FormValidation.utils.closest(e.element, '.mod-input,.checkbox,.radio-button');
        FormValidation.utils.classSet(container, {
          'is-validation-failed': value === '' || !e.valid,
        });
      }
    })
    .on('core.form.valid', () => {
      const requiredFormData = {};
      const otherFormData = {};
      // eslint-disable-next-line consistent-return
      const getInputData = (input) => {
        if (input.type !== 'checkbox' && input.type !== 'radio' && input.type !== 'file') {
          return input.value.trim();
        }
        if (input.type === 'radio') {
          if (input.checked) {
            return input.value.trim();
          }
        }
        if (input.type === 'checkbox') {
          if (input.checked) {
            return input.value.trim();
          }
        }
      };

      form.querySelectorAll('input, textarea, select').forEach((input) => {
        const getValue = getInputData(input);
        if (getValue !== undefined && getValue !== '' && getValue !== 'on') {
          if (input.hasAttribute('required')) {
            requiredFormData[input.name] = getInputData(input);
          } else {
            otherFormData[input.name] = getInputData(input);
          }
        }
      });
      axiosAction(requiredFormData, otherFormData);
    });
};

document.addEventListener('DOMContentLoaded', async () => {
  const eventForm = document.getElementById('event-form-form');

  if (eventForm) {
    eventHandleForm(eventForm);
  }
});
